export default __webpack_public_path__ + "static/media/login.ddbb8198.png";